import React from 'react';
import { observer } from 'mobx-react-lite';
import chatStore from '../stores/chatStore';
import { useTheme } from '../theme/ThemeContext';

const ModeToggle = observer(() => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';
    const locked = chatStore.isModeLocked;

    const btn = (mode, label) => {
        const active = chatStore.mode === mode;
        return (
            <button
                type="button"
                disabled={locked}
                title={
                    locked
                        ? 'Тип диалога задаётся первым сообщением и больше не меняется'
                        : undefined
                }
                onClick={() => {
                    if (!locked) chatStore.setMode(mode);
                }}
                className={`rounded-lg px-2 py-1.5 text-center text-[11px] font-medium transition sm:px-3 sm:text-xs ${
                    locked ? 'cursor-default' : ''
                } ${
                    active
                        ? isDark
                            ? 'bg-white/15 text-white'
                            : 'bg-white text-gray-900 shadow-sm'
                        : locked
                          ? isDark
                              ? 'text-white/25'
                              : 'text-gray-300'
                          : isDark
                            ? 'text-white/60 hover:text-white'
                            : 'text-gray-500 hover:text-gray-800'
                }`}
            >
                {label}
            </button>
        );
    };

    return (
        <div
            className={`inline-flex shrink-0 rounded-xl border p-0.5 ${
                locked ? 'opacity-80' : ''
            } ${isDark ? 'border-white/10 bg-white/5' : 'border-black/10 bg-black/[0.03]'}`}
            title={
                locked
                    ? 'Тип диалога задаётся первым сообщением и больше не меняется'
                    : undefined
            }
        >
            {btn('chat', 'Чат')}
            {btn('image', 'Фото')}
            {chatStore.showMediaTabs ? btn('audio', 'Аудио') : null}
            {chatStore.showMediaTabs ? btn('video', 'Видео') : null}
        </div>
    );
});

export default ModeToggle;
